import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "'ZCOOL KuaiLe', cursive" }}>
              <Link to="/" className="hover:text-primary-400 transition-colors duration-200">蜜桃视频</Link>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              专注甜蜜生活方式的短视频平台，汇聚美食、旅行、萌宠、情感等海量优质内容。发现、创作、分享你的精彩瞬间。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/category/meishi" className="hover:text-primary-400 transition-colors duration-200">热门分类</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                { to: '/category/meishi', label: '美食' },
                { to: '/category/lvxing', label: '旅行' },
                { to: '/category/mengchong', label: '萌宠' },
                { to: '/category/qinggan', label: '情感' },
                { to: '/category/shenghuo', label: '生活' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-primary-400 transition-colors duration-200">关于我们</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                { to: '/about', label: '品牌介绍' },
                { to: '/about', label: '用户口碑' },
                { to: '/about', label: '联系我们' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">下载蜜桃视频</h4>
            <p className="text-sm text-foreground-300 mb-3">扫码下载APP，随时随地发现精彩</p>
            <button className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 whitespace-nowrap transition-colors duration-200 cursor-pointer">
              立即下载
            </button>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 蜜桃视频 MitaoVideo. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200" rel="nofollow">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}